<template>
  <div class="flex flex-between">
    <div class="conditions">
      <el-select
        v-model="condition.userAttr"
        size="small"
        value-key="id"
        style="width: 140px"
        @change="getUserAttr(condition)"
        class="mr10"
        placeholder="请选择用户属性"
      >
        <el-option
          v-for="(attr, aI) in userAttrList"
          :key="aI"
          :label="attr.ruleName + '(' + attr.calcMode + ')'"
          :value="attr"
        ></el-option>
      </el-select>
      <el-cascader
        size="small"
        v-model="condition.symbol"
        style="width: 140px"
        class="mr10 tag-cascader"
        :options="condition.options"
        :show-all-levels="false"
      ></el-cascader>
      <!-- 非日期类型 -->
      <el-input
        v-if="
          condition.userAttr &&
            (condition.userAttr.calcMode === 'string' ||
              condition.userAttr.calcMode === 'int') &&
            condition.symbol &&
            condition.symbol[0] !== 'IS NOT NULL' &&
            condition.symbol[0] !== 'NULL'
        "
        size="small"
        style="width: 140px"
        v-model="condition.value"
        placeholder="请输入值"
      ></el-input>
      <!-- 日期类型 -->
      <template v-if="condition.symbol && condition.symbol[0]">
        <!-- 绝对时间 -->
        <template v-if="condition.symbol[0] === 'ABSOLUTE TIME'">
          <template v-if="condition.symbol[1] !== 'BETWEEN'">
            <el-date-picker
              v-model="condition.value"
              type="date"
              size="small"
              class="tag-datepicker"
              style="width:140px"
              placeholder="选择日期"
            >
            </el-date-picker>
          </template>
          <template v-else>
            <div class="mt10">
              <el-date-picker
                v-model="condition.value"
                type="datetimerange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </template>
        </template>
        <!-- 相对当前时间 -->
        <template v-if="condition.symbol[0] === 'RELATIVE TIME'">
          <div class="mt10">
            <span class="mr10">在</span>
            <el-select
              size="small"
              style="width: 120px"
              class="mr10"
              v-model="condition.relativeDateType"
            >
              <el-option label="过去" value="PAST TIMES"></el-option>
              <el-option label="未来" value="FUTURE"></el-option>
            </el-select>
            <el-input
              size="small"
              style="width: 120px"
              class="mr10"
              v-model="condition.value"
              type="number"
              placeholder="天数"
            ></el-input>
            <span class="mr10">天</span>
            <el-select
              size="small"
              style="width: 120px"
              v-model="condition.relativeDateRange"
            >
              <el-option label="之内" value="WITHIN"></el-option>
              <el-option
                label="之前"
                v-if="condition.relativeDateType === 'PAST TIMES'"
                value="BEFORE"
              ></el-option>
              <el-option v-else label="之后" value="AFTER"></el-option>
            </el-select>
          </div>
        </template>
        <!-- 相对当前时间区间 -->
        <template v-if="condition.symbol[0] === 'RELATIVE BETWEEN TIME'">
          <div class="mt10 relative-between-time">
            <span class="mr10">在</span>
            <el-select
              size="small"
              style="width: 120px"
              class="mr10"
              v-model="condition.relativeDateType"
            >
              <el-option label="过去" value="PAST TIMES"></el-option>
              <el-option label="未来" value="FUTURE"></el-option>
            </el-select>
            <el-input
              class="mr10"
              size="small"
              type="number"
              v-model="condition.betweenStartDay"
              placeholder="天数"
              style="width: 100px"
            ></el-input>
            <span class="mr10"
              >天至<template v-if="condition.relativeDateType === 'PAST TIMES'">
                过去
              </template>
              <template v-else>未来</template>
            </span>
            <el-input
              class="mr10"
              size="small"
              type="number"
              v-model="condition.betweenEndDay"
              placeholder="天数"
              style="width: 100px"
            ></el-input>
            天之内
          </div>
        </template>
      </template>
    </div>
    <div class="flex">
      <div class="minus-wrapper">
        <span
          class="hmicon icon-jianhao pointer"
          @click="removeChild(rule, conditionIndex)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss"></style>
